import {PrimolyticsService, beacon} from '../../../../analytics/primolytics.service';
import {Component, Inject, Output, EventEmitter} from 'ng-metadata/core';
import {LibraryCardMenuService, OPAC_TYPE} from './libraryCardMenu.service';
import {getVid} from '../../../../appConfig/appConfigForward';
import {MobileMenu} from "../../menu.service";
import {AnalyticsUtils} from "../../../../nddUtils/analyticsUtils.service";
//your imports go here

@Component({
    selector: 'prm-library-card-menu',
    templateUrl: 'components/search/topbar/userArea/libraryCard/library-card-menu.html',
})


export class PrmLibraryCardMenu {
    private opacType: OPAC_TYPE;
    private lang;

    @Output() actionEvent = new EventEmitter<void>();

    private KEY_CODE = {
        COMMA: 188,
        SEMICOLON: 186,
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT_ARROW: 37,
        UP_ARROW: 38,
        RIGHT_ARROW: 39,
        DOWN_ARROW: 40,
        TAB: 9,
        BACKSPACE: 8,
        DELETE: 46
    };

    constructor(private libraryCardMenuService: LibraryCardMenuService,
                @Inject('topBarIcons') public topBarIcons,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$window') private $window: ng.IWindowService,
                private primolyticsService: PrimolyticsService,
                private mobileMenu: MobileMenu,
                private analyticsUtils: AnalyticsUtils,
    ) {
        this.opacType = this.libraryCardMenuService.getOpacType();
        this.lang = this.$translate.use();
    }

    public isOvp() {
        return this.opacType === OPAC_TYPE.OVP;
    }

    @beacon({'p': 'general', 'op': 'gotoMyAccount'})
    public goToMyLibraryCard() {
        if (this.isOvp()) {
            this.$state.go('account', {vid: getVid(), lang: this.lang, section: 'overview'}, {reload: true});
        } else {
            this.$window.open(this.libraryCardMenuService.getIlsBaseUrl(), '_blank');
        }
        this.actionEvent.emit(null);
    }

    @beacon({'p': 'general', 'op': 'gotoMyAccount'})
    public goToUserSettings() {
        this.$state.go('account', {vid: getVid(), lang: this.lang}, {reload: true});
        this.actionEvent.emit(null);
    }

    public getLibraryCardAriaLabel() {
        return this.isOvp() ? 'nui.aria.menu.librarycard' : 'nui.aria.menu.libraycard.link';
    }

    // @HostListener('keydown', ['$event'])
    private keydownSupport(e) {

        if (this.mobileMenu.getLinksMenuVisible() == false) {
            let keyCodes = this.KEY_CODE;

            if (e.keyCode === 9) {
                e.preventDefault();
                return document.querySelector('prm-authentication button').focus();
            }
        }
    }

    public sendAnalytics() {
        let payload = this.getAnalyticsPayload();
        this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.USER_MENU_LINKS, payload);
    }

    private getAnalyticsPayload(){
        return {
            'User Menu Link Name' : 'my library card'
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/userArea/libraryCard/libraryCardMenu.directive.ts